import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { useSessionContext } from 'hooks/SessionContext'

import Brand from 'helpers/brand'

import Api from 'services/api'

import FeatureTour from 'types/FeatureTour'

const useActiveFeatureTour = () => {
  const { session: { isUnknown, isAdmin, currentRole, dealerPlan } } = useSessionContext()

  const [featureTour, setFeatureTour] = useState<FeatureTour | null>(null)
  const [isFeatureTourLoaded, setIsFeatureTourLoaded] = useState(false)

  const brand = Brand.current()
  const currentPath = useLocation().pathname

  useEffect(() => {
    if (isUnknown || isAdmin) {
      return
    }

    Api.FeatureTours.get(brand)
      .then((response) => {
        if (response) {
          setFeatureTour(response)
          setIsFeatureTourLoaded(true)
        } else {
          setFeatureTour(null)
          setIsFeatureTourLoaded(true)
        }
      })
      .catch(() => {
        setFeatureTour(null)
        setIsFeatureTourLoaded(true)
      })
  }, [isUnknown, brand, isAdmin, currentRole, dealerPlan, currentPath])

  return { featureTour, isFeatureTourLoaded }
}

export default useActiveFeatureTour
